export default{
    users:[],
    user:[],
    vendedores:[],
    solicitantes:[],
    isOk: false,
    error:null,
    errorMessage:'',

}